(function ($) {

    $(document).on('click', '.sa2', function () {
        var el = $(this);

        el.addClass('registering');
        $('.sa1').trigger('click');

    });

    var buildHtml = function (data) {
        var defaultItem = {
            url: '',
            title: '',
            white_logo: '',
            venue: '',
            city: '',
            country: '',
            register_status: '',
            on_sale_link: '',
            registration_title: '',
            registration_code: '',
            registration_notice: '',
            registration_types: '',
            subscription_code: ''
        };

        return _(data)
            .filter({'visibility': {'events': true}})
            .map(function(val) {
                val = $.extend({}, defaultItem, val);

                var rtypes = false;

                var rtypeshtml =
                    _(val.passport.registration_types)
                    .filter(item => item.locale === pplang)
                    .map(value => {
                        rtypes = true;
                        return `
                        <li class="mb25">
                            <p>${value.info}</p>
                            <a data-regcode="${value.code}" class="btn-main aqua-btn btn-lg mb20">${value.type} <span class="fas fa-chevron-right"></span></a>
                        </li>`;

                    })
                    .join('');

                var location_label = val.passport.location_label;
                var location = val.locations[0];

                if (location) {
                    if (location_label) {
                        location_label += ` &mdash;`;
                    }
                    if (location.venue) {
                        location_label += ` ${location.venue} &mdash;`;
                    }
                    if (location.city) {
                        location_label += ` ${location.city},`;
                    }
                    if (location.country) {
                        location_label += ` ${location.country}`;
                    }
                }

                let buttonMap = {
                    'Get Updates': {
                        attributes: {
                            class: ['outline-btn', 'get-updates'],
                            'data-updates': val.passport.subscription_code,
                        },
                        content: `${_rbtnupdates} <span class="fas fa-chevron-right"></span>`,
                    },
                    'On Sale': {
                        attributes: {
                            href: val.on_sale_link,
                            target: '_blank',
                            class: ['on-sale', 'gray-btn'],
                        },
                        content: `${_rbtnbuy} <span class="fas fa-chevron-right"></span>`,
                    },
                    'Third Party Registration': {
                        attributes: {
                            href: val.on_sale_link,
                            target: '_blank',
                            class: ['register2', upp_assets.buttons.registration_btn, 'tprfill'],
                        },
                        content: `${_rbtnregister} <span class="fas fa-chevron-right"></span>`,
                    },
                    'Registration Available': {
                        attributes: {
                            class: ['register', upp_assets.buttons.registration_btn],
                            'data-regtypes': rtypes,
                            'data-regurl': val.on_sale_link,
                            'data-regnotice': val.passport.registration_notice,
                            'data-regcode': val.passport.registration_code,
                            'data-regtitle': val.passport.registration_title,
                        },
                        content: `${_rbtnregister} <span class="fas fa-chevron-right"></span>`,
                    },
                    'Closed': {
                        attributes: {
                            class: ['disabled', 'outline-btn'],
                            'data-regtypes': rtypes,
                            'data-regurl': val.on_sale_link,
                            'data-regnotice': val.passport.registration_notice,
                            'data-regcode': val.passport.registration_code,
                            'data-regtitle': val.passport.registration_title,
                        },
                        content: _rbtnclosed,
                    },
                    'Coming Soon': {
                        attributes: {
                            class: ['coming-soon', 'disabled'],
                        },
                        content: _rbtnsoon,
                    },
                    'Sold Out': {
                        attributes: {
                            class: ['sold-out', 'red-disabled'],
                        },
                        content: _rbtnsoldout,
                    },

                };

                let buttonEntry = buttonMap[val.passport.register_status] || {
                    attributes: { class: ['disabled'] },
                    content: val.passport.register_status || '',
                };

                let buttonAttributes = mergeRecursive(
                    {
                        class: ['btn-main', 'btn-lg'],
                    },
                    buttonEntry.attributes
                );

                buttonAttributes.class = buttonAttributes.class.join(' ');

                let buttonContent = buttonEntry.content || '';

                var buttonHTML = $('<a>').attr(buttonAttributes).html(buttonContent).prop('outerHTML');

                var logoHTML = val.media.white_logo ? `<img src="${val.media.white_logo}" width="250" alt="${val.title}">` : val.title;

                return `
                <article data-regitem="${val.passport.registration_code}" class="${val.type_key} ${convertToSlug(val.passport.register_status)}">
                    <a href="${val.url}" target="_blank" class="event">${logoHTML}</a>
                    <p class="details">
                        <img src="${upp_assets.images.map_pin}" alt="" width="10">
                        <span class="location">${location_label}</span> <span class="date">${val.date.label}</span> <span class="hide">${val.title} ${val.type_key}</span>
                    </p>
                    ${buttonHTML}
                    <div class="hide"><div class="types"><ul>${rtypeshtml}</ul></div></div>
                </article>`;
            })
            .join('');
    }

    window.loadRegistrationPage = _.memoize(function (eventsContainer, modalContainer, eventsNav) {
        var $eventsContainer = $(eventsContainer);
        var $modalContainer = $(modalContainer);
        var _updatesGuest = $('#updates-guest');

        $eventsContainer
            .on('click', 'a.register', function (e) {
                e.preventDefault();
                var el = $(this);
                var code = el.data('regcode');
                var title = el.data('regtitle');
                var types = el.data('regtypes');
                var regurl = el.data('regurl');
                var typeshtml = el.parent().find('.types').html();

                if (!!$('#all-events.pending').length) {
                    el.addClass('registering');
                    showResult(_verifyemailregister, 'error');
                    $modalContainer.find('div.types-text, div.register-text, div.guest-text').hide();
                    $modalContainer.find('div.pending-text').show();
                    $('.btn-resend').on('click', function (e) {
                        e.preventDefault();
                        sendVerify(upp_page.verify);
                        showResult(_verifyemailregister, 'error');
                        $modalContainer.fadeOut(300);
                        showResult(_sendingverification, 'info');
                        setTimeout(function () {
                            showResult(_verifysent, 'success');
                            el.removeClass('registering');
                        }, 1500);
                    });
                }
                else if (!!$('#all-events.guest').length) {
                    el.addClass('registering');
                    $modalContainer.find('div.types-text, div.register-text, div.pending-text').hide();
                    $modalContainer.find('div.guest-text').show();
                }
                else {
                    el.addClass('registering');
                    $modalContainer.find('div.pending-text, div.guest-text').hide();
                    $modalContainer.find('div.register-text')
                        .find('a.confirm').remove().end()
                        .find('strong.regtitle').text(title);

                    if (types) {
                        $modalContainer.find('div.register-text').hide();
                        $modalContainer.find('div.types-text').show();
                        $('.types-text .types').html(`<ul>${typeshtml}</ul>`);
                        $('.types-text .types>ul a').on('click', function (e) {
                            e.preventDefault();
                            var el = $(this);
                            var type = el.data('regcode');
                            $modalContainer.find('div.types-text').hide();
                            if (!$('.typesback').length) {
                                $modalContainer.find('div.register-text').find('.actions').prepend(`<a class="btn-main typesback mr25 ${upp_assets.buttons.outline_btn} btn-lg mb50" data-regcode="${code}"><span class="fas fa-chevron-left fa-sm"></span> ${_goback}</a>`);
                            }

                            if (!$('a.confirm').length) {
                                $modalContainer.find('div.register-text').find('.actions').append(`<a class="btn-main ${upp_assets.buttons.primary_btn} btn-lg confirm mb50" data-regtype="${type}" data-regcode="${code}">${_confirmreg} <span class="fas fa-chevron-right"></span></a>`);
                            }
                            $modalContainer.find('div.register-text').show();

                            $('.regtype').remove();
                            $('#confirm-info').append(`<li class="regtype">${_regtype}: <strong>${type}</strong></li>`)
                        });

                    }
                    else {
                        $('.regtype').remove();
                        $('.typesback').remove();
                        $modalContainer.find('div.register-text')
                            .find('.actions')
                            .append(`<a class="btn-main ${upp_assets.buttons.primary_btn} btn-lg confirm mb50" data-regcode="${code}">${_confirmreg} <span class="fas fa-chevron-right"></span></a>`)
                            .end()
                            .show();
                    }

                    var sharetitle = 'Register for tickets to ' + title;
                    var sharebuilder = socialShare(regurl, sharetitle, code);

                    $('.eventregname').html(title);
                    $('#register-share .share').html(sharebuilder);

                }

                $modalContainer.fadeIn(300);
            }).on('run-register', 'a.register', function (event, code, type, regaccept) {
            var el = $(this);

            var autotype = el.data('autotype');
            if (autotype) {
                type = autotype;
            }
            var regdata = {
                source: document.location.hostname,
                type: type,
                accepted: regaccept,
            };

            passport.register(code, regdata)
                .done(function (data, textStatus) {
                    var regdate = moment(data.created_at).format('MMMM Do, YYYY');
                    var regcode = data.regcode || '';

                    // TODO: Drop 'Lead' once GTM trigger (52) and FB tag (28) are cleaned up.
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'Lead',
                        'leadEventId': data.event,
                        'leadEventInstance': data.instance,
                        'leadEventType': data.type,
                    });
                    window.dataLayer.push({
                        'event': 'generate_lead',
                        'lead_source': 'registration',
                        'currency': 'USD',
                        'value': 0
                    });

                    el.trigger('mark-success', [data, textStatus]);

                    setTimeout(function () {
                        var title = $('.register-text').find('strong.regtitle').text();
                        //$eventsContainer.find('article[data-regitem="'+code+'"]').find('.regcode').html(regcode);
                        $eventsContainer.find(`article[data-regitem="${code}"]`).find('.regdate').html(regdate);
                        $eventsContainer.find(`article[data-regitem="${code}"]`).find('.regtype').html(regdata.type);
                        showResult(title + ' ' + _registersuccess, 'success');
                        //scrollToTop();
                    }, 1500);

                })
                .fail(function (jqXHR, textStatus, error) {
                    el.trigger('mark-fail', [jqXHR, textStatus, error]);
                });
        }).on('mark-success', 'a.register', function (e) {
            var el = $(this);
            var datacode = el.data('regcode');
            var datanotice = el.data('regnotice');
            var title = el.data('regtitle');
            var regurl = el.data('regurl');
            var sharetitle = `Register for tickets to ${title}`;
            var sharebuilder = socialShare(regurl, sharetitle, datacode);

            el.html(`${_regbtnhtml} <span class="check">&#x2713;</span>`)
                .addClass('registering');
            el.parent().append(regHTML);

            el.html(`${_regbtnhtml} <span class="check">&#x2713;</span>`)
                .addClass('registered')
                .removeClass('register')
                .removeClass('registering');

            if (datanotice) {
                if (datanotice == 2) {
                    el.parent().find('.regnotice').text(_regaccepted2_2);
                }
                else if (datanotice == 3) {
                    el.parent().find('.regnotice').text(_regaccepted2_3);
                }
                else if (datanotice == 4) {
                    el.parent().find('.regnotice').text(_regaccepted2_4);
                }

                setTimeout(function () {
                    $(`article[data-regitem="${datacode}"] .registered-summary .right`).html(`<div class="events-share"><strong>Share with your friends:</strong>${sharebuilder}</div>`);
                    $('.registered-summary').slideDown(300);
                }, 500);
            }


        })
            .on('mark-success', 'a.closed', function (e) {
                var el = $(this);
                var datacode = el.data('regcode');
                var datanotice = el.data('regnotice');
                var title = el.data('regtitle');
                var regurl = el.data('regurl');
                var sharetitle = `Register for tickets to ${title}`;
                var sharebuilder = socialShare(regurl, sharetitle);

                el.html(`${_regbtnhtml} <span class="check">&#x2713;</span>`)
                    .addClass('registering');
                el.parent().append(regHTML);
                setTimeout(function () {

                    el.html(`${_regbtnhtml} <span class="check">&#x2713;</span>`)
                        .addClass('registered')
                        .removeClass('register registering');

                    if (datanotice == 2) {
                        el.parent().find('.regnotice').text(_regaccepted2_2);
                    }
                    else if (datanotice == 3) {
                        el.parent().find('.regnotice').text(_regaccepted2_3);
                    }

                    setTimeout(function () {
                        $(`article[data-regitem="${datacode}"] .registered-summary .right`).html(`<div class="events-share"><strong>Share with your friends:</strong>${sharebuilder}</div>`);
                        $('.registered-summary').slideDown(300);
                    }, 500);

                }, 1500);

            })
            .on('mark-fail', 'a.register', function (e) {
                var el = $(this);
                el.html(_regerror)
                    .addClass('error')
                    .removeClass('registering');
                setTimeout(function () {
                    el.html(_regerror2);
                    setTimeout(function () {
                        el.html(`${_regbtnhtml} <span class="fas fa-chevron-right"></span>`)
                            .removeClass('error');
                    }, 3000);
                }, 1500);
                log("Failed registering for " + el.data('regcode'));
            });

        $modalContainer.on('click', 'a.confirm', function () {
            var code = $(this).data('regcode');
            var type = $(this).data('regtype');

            var regaccept = getUrlParam('rcode');

            if (readCookie('register')) {
                regaccept = readCookie('register');
            }
            setTimeout(function () {
                $('.rgbtn').trigger('click');
            }, 1000);
            $modalContainer.fadeOut(300);
            $eventsContainer.find(`a[data-regcode="${code}"]`).trigger('run-register', [code, type, regaccept]);
        });

        $modalContainer.on('click', 'a.typesback', function () {
            $modalContainer.find('div.register-text').hide();
            $modalContainer.find('div.types-text').show();
        });

        $modalContainer.on('click', '.md-close', function (e) {
            var $this = $(this);
            setTimeout(function () {
                $('a.registering')
                    .addClass('register')
                    .removeClass('registering');
            }, 1000)
            e.preventDefault();
            $this.parent().fadeOut(300);
        });
        $(document).on("keyup", function (event) {
            if (event.keyCode == 27 && !!$modalContainer.find('.md-close').length) {
                $modalContainer.find('.md-close').trigger('click');
            }
        });

        $eventsContainer
            .on('click', 'a.get-updates', function (e) {

                var el = $(this);
                var code = $(this).data('updates');
                e.preventDefault();

                if (!!$('#all-events.pending').length) {
                    showResult(_verifyemailregister, 'error');
                    _updatesGuest.find('h1').html(_updatestextPending);
                    _updatesGuest.find('p').html(_emailverifyupdates);
                    _updatesGuest.find('div.guest-text .guest-text').hide();
                    _updatesGuest.find('div.guest-text .pending-text').show();
                    _updatesGuest.fadeIn(300);

                    _updatesGuest.find('.btn-resend').on('click', function (e) {
                        e.preventDefault();
                        showResult(_verifyemailregister, 'error');

                        _updatesGuest.fadeOut(300);
                        scrollToTop();

                        showResult(_sendingverification, 'info');
                        setTimeout(function () {
                            showResult(_verifysent, 'success');
                        }, 3000);
                    })
                }
                else if (!!$('#all-events.guest').length) {
                    _updatesGuest.find('div.guest-text .guest-text').show();
                    _updatesGuest.find('div.guest-text .pending-text').hide();
                    _updatesGuest.find('h1').html(_updatestext1);
                    _updatesGuest.find('p').html(_agreesignup2);
                    _updatesGuest.fadeIn(300);

                }
                else {
                    el.addClass('registering');
                    el.trigger('run-subscribe', [code]);
                }
            })
            .on('run-subscribe', 'a.get-updates', function (event, code) {
                var el = $(this);
                passport.subscribe(code)
                    .done(function (data, textStatus) {
                        el.trigger('mark-success', [data, textStatus]);
                    })
                    .fail(function (jqXHR, textStatus, error) {
                        el.trigger('mark-fail', [jqXHR, textStatus, error]);
                    });
            })
            .on('mark-success', 'a.get-updates', function (e, code) {
                var el = $(this);
                el.addClass('registering');
                setTimeout(function () {
                    el.html(_subscribed + ' <i class="fas fa-check"></i>')
                        .addClass('subscribed')
                        .removeClass('get-updates')
                        .removeClass('registering');
                }, 1000);
            })
            .on('mark-fail', 'a.get-updates', function (e, code) {
                var el = $(this);
                el.html(_regerror)
                    .addClass('error')
                    .removeClass('registering');

                setTimeout(function () {
                    el.html(_regerror2);
                    setTimeout(function () {
                        el.html(_rbtnupdates + ' <span class="fas fa-chevron-right"></span>')
                            .removeClass('error');
                    }, 3000);
                }, 1500);

                log("Failed subscribing to " + code);
            });

        $(document).on('rebuild-page', function (event, eventsPromise, passportPromise) {
            eventsPromise.done(function (data) {
                $eventsContainer.html(buildHtml(data));

                var autotype = getUrlParam('type');

                if (autotype) {
                    autotype = autotype.replace('week', 'Week ');
                }
                $('article[data-regitem="ibiza-2018"] a.register').attr('data-autotype', autotype);

                // Sort events list by class name
                if (sortbytype) {
                    var tasks = document.querySelector('#all-events'),
                        items = document.querySelectorAll('#all-events > article'),
                        classlist = ['register', 'register2', 'closed', 'on-sale', 'get-updates', 'coming-soon', 'sold-out'];
                    for (var i = 0, arr = classlist; i < arr.length; i++) {
                        for (var j = 0; j < items.length; j++) {
                            if (~(" " + items[j].className + " ").indexOf(" " + arr[i] + " ")) {
                                tasks.appendChild(items[j]);
                            }
                        }
                    }
                }

                if (window.location.hash) {
                    var filter = window.location.hash.substring(1);
                    if (filter == 'all') {
                        return;
                    }
                    filter = filter.replace('-', ' ');
                    $('#event-search').val(filter);
                    updateList();
                }


            });

            // Update the registration page selections
            $.when(eventsPromise, passportPromise).done(function (events, passport) {

                var fname = passport[0].firstname;
                var lname = passport[0].lastname;
                var fillemail = passport[0].email;

                $('.tprfill').each(function (index) {
                    var href = $(this).attr('href');
                    href = `${href}?first=${fname}&last=${lname}&email=${fillemail}`;
                    $(this).attr('href', href);
                    //log(href);
                });

                //add restriction message and register prevent action
                var ppstatus = passport[0].status;
                $eventsContainer.removeClass('guest')
                if (ppstatus == 'active') {
                    registrationNotice(passport[0]);
                }
                else {
                    showResult(_emailverifydashboard, 'warning');
                    _allevents.addClass('pending');
                }

                var level = passport[0].points_level;

                //log(level);

                function allowPurchase(startdate, level) {
                    startdate = moment(startdate);
                    if (level == 'gold') {
                        return startdate.subtract(1, "hour");
                    }
                    else if (level == 'platinum') {
                        return startdate.subtract(2, "hour");
                    }
                    else {
                        return startdate;
                    }
                }


                $.each(passport[0].registrations, function (index, registration) {
                    var registrationCode = `${registration.event}-${registration.instance}`;
                    $eventsContainer.find('article[data-regitem="' + registrationCode + '"]').each(function () {

                        var el = $(this);

                        // log(registration);
                        var regdate = moment(registration.created_at).format('MMMM Do, YYYY');
                        var regcode = registration.regcode;

                        //var regcode = registration.regcode;
                        el.find('a.register').trigger('mark-success');
                        el.find('a.closed').trigger('mark-success');
                        el.find('a.closed').removeClass('disabled');
                        el.find('.regdate').html(regdate);
                        //el.find('.regcode').html(regcode);
                        el.find('.regtype').html(registration.type);

                    });
                });


                //$('a.register:last').trigger('click');
                $.each(passport[0].subscriptions, function (index, subscription) {
                    $eventsContainer.find('a.get-updates').each(function () {
                        var el = $(this);
                        var code = el.data('updates');
                        var subcode = passport[0].subscriptions[index].code;

                        if (code == subcode) {
                            el.trigger('mark-success');
                        }
                    });
                });

                if (window.location.hash) {
                    var filter = window.location.hash.substring(1);
                    if (filter == 'all') {
                        return;
                    }
                    filter = filter.replace('-', ' ');
                    $('#event-search').val(filter);
                    updateList();
                }

            });
        });


        if (!!_eventsearch.length) {

            $.extend($.expr[":"], {
                "containsIN": function (elem, i, match, array) {
                    return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
                }
            });

            var updateList = function () {

                var allRows = _allevents.find('article');
                allRows.removeClass('hiddenRow');
                var clickedText = _eventsearch.val();
                var theCounter = 0;

                allRows.each(function () {
                    //$(this).contains
                    if (!$(this).is(`:containsIN("${clickedText}")`)) {
                        $(this).addClass('hiddenRow');
                    }
                    else {
                        theCounter++;
                    }
                });

                if (theCounter == 0) {
                    $('#noevents').fadeIn(300);
                }
                else {
                    $('#noevents').fadeOut(10);
                }
            }

            updateList();

            _eventsearch.on('keyup', function (e) {
                updateList();
                if (!$('a.all-events').hasClass('active')) {
                    $('a.all-events').trigger('click');
                }
            });

            _eventsearch.on('blur', function (e) {
                updateList();
            });
        }

        $('#noevents').fadeOut(10);

        $('#events-nav a').on('click', function (e) {
            e.preventDefault();

            var el = $(this);

            if (el.hasClass('active') && !el.hasClass('all-events')) {
                $('a.all-events').trigger('click');
                return;
            }

            try {
                window.location.hash = this.hash;
                //history.pushState(null, null, this.hash);
                $(`#upp${this.hash.substring(1)}`).fadeIn();
            }
            catch (error) {
                console.log(error);
            }

            _eventsNav.find('a.active').removeClass('active');
            el.addClass('active');

            var sorter = el.attr('data-sort');
            if (sorter != 'all') {
                _allevents.find(`article:not(.${sorter})`).slideUp(200);
                _allevents.find(`article.${sorter}`).fadeIn(300);
            }
            else {
                _allevents.find('article').fadeIn(300);
            }

        });
    });
})(jQuery);
